// Lib
import React from 'react';

// Components
import ImageModalV2Editor from './ImageModalV2Editor';

// Analytics
import { intercomTrackEvent } from '../../../../../analytics/intercomService';

// Utils
import { gridPointsToPixels } from '../../../../../utils/grid/gridUtils';

// Types
import { ImageModalV2EditModeProps } from '../imageModalV2Types';

// Constants
import { IMAGE_MODAL_FOOTER_SIZE } from '../../imageModalConstants';

type ImageModalV2CropModeContentProps = ImageModalV2EditModeProps & {
    fittedImageWidth: number;
    fittedImageHeight: number;
    captionHeight: number;
};

/**
 * V2 crop entry point: maps measured V2 layout sizes onto editor viewport props.
 */
const ImageModalV2CropModeContent: React.FC<ImageModalV2CropModeContentProps> = ({
    fittedImageWidth,
    fittedImageHeight,
    captionHeight,
    gridSize,
    ...editModeProps
}) => {
    // Matches ImageModalEditor's getElementModalSize horizontal margin default.
    const horizontalMarginPx = gridPointsToPixels(20, gridSize);
    // Matches ImageModalEditor's modalVerticalMarginGU override.
    const verticalMarginPx = gridPointsToPixels(5, gridSize);
    const idealHeight = fittedImageHeight + captionHeight;
    const { finishEditingMode } = editModeProps;

    const closeEditorCallback = () => {
        intercomTrackEvent('edited-image');

        setTimeout(finishEditingMode, 50);
    };

    return (
        <ImageModalV2Editor
            {...editModeProps}
            gridSize={gridSize}
            windowWidth={fittedImageWidth + horizontalMarginPx}
            windowHeight={idealHeight + IMAGE_MODAL_FOOTER_SIZE + verticalMarginPx}
            idealHeight={idealHeight}
            cancelEditing={finishEditingMode}
            afterSaveCb={closeEditorCallback}
        />
    );
};

export default ImageModalV2CropModeContent;
